import React from "react";
import styles from "./Styles/BillSection.module.css";
import { getDownloadLink } from "../../utils/appLinks";

const BillSection: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <img
          src={"/images/bills/airtime.png"}
          alt="Airtime top-up in the Sprinterwave app"
          className={styles.image}
        />
        <img
          src={"/images/bills/tv.png"}
          alt="TV subscription payment in the Sprinterwave app"
          className={`${styles.image} ${styles.rotate1}`}
        />
      </div>

      <div className={styles.textContent}>
        <span className={styles.eyebrow}>Cashback rewards</span>
        <h2>
          Smart Bills, Big <span className={styles.brand}>Rewards</span>
        </h2>

        <ol className={styles.stepsList}>
          <li>
            <div>
              <h3>Airtime Bonus Boost</h3>
              <p>
                Get 20% cashback every time you top up. Recharge your phone
                and enjoy instant savings.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h3>Affordable Data Deals</h3>
              <p>
                Buy data at unbeatable rates with 10% cashback. Stay online
                longer without breaking the bank.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h3>TV Subscriptions with Perks</h3>
              <p>
                Enjoy 10% cashback and promo deals on all your favorite TV
                packages. Stream more, spend less.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h3>Power & Save (Electricity)</h3>
              <p>
                Pay your electricity bills and get 20% cashback instantly.
                Light up your home while keeping your wallet happy.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h3>Result Checker Access</h3>
              <p>
                Easily purchase result checker pins for WAEC, NECO, and more.
                Fast delivery, secure payments, and always available when you
                need them.
              </p>
            </div>
          </li>
        </ol>

          <a href={getDownloadLink()} target="_blank" rel="noopener noreferrer">
        <button className={styles.ctaButton}>
            Get the app →
        </button>
          </a>
      </div>
    </div>
  );
};

export default BillSection;